// extracted by mini-css-extract-plugin
export default {"container":"Submissions_container__Nr1gK"};